// extracted by mini-css-extract-plugin
export default {"list":"ItemList_list__CkvTR"};